import { z } from "zod";
import {
  EventCreatableSchema,
  EventUpdateableHostViewSchema,
} from "./event.schemas.js";

export const EventBrandingFieldSchema = z.enum([
  "logoUrl",
  "sponsorLogoUrl",
  "keyVisualUrl",
]);

export type EventBrandingField = z.infer<typeof EventBrandingFieldSchema>;

export const EventBrandingUploadRequestSchema = z.object({
  field: EventBrandingFieldSchema,
  mimeType: z.string().min(1),
});

export type EventBrandingUploadRequest = z.infer<
  typeof EventBrandingUploadRequestSchema
>;

export const EventBrandingUploadResultSchema = z.object({
  uploadUrl: z.url(),
  expiresAt: z.iso.datetime(),
  uploadKey: z.string().min(1),
});

export type EventBrandingUploadResult = z.infer<
  typeof EventBrandingUploadResultSchema
>;

export const EventBrandingPendingReferenceSchema = z.object({
  uploadKey: z.string().min(1),
  etag: z.string().min(1),
});

export type EventBrandingPendingReference = z.infer<
  typeof EventBrandingPendingReferenceSchema
>;

export const EventBrandingUploadsSchema = z
  .partialRecord(EventBrandingFieldSchema, EventBrandingPendingReferenceSchema)
  .optional();

export const CreateEventRequestSchema = EventCreatableSchema.unwrap()
  .extend({ brandingUploads: EventBrandingUploadsSchema })
  .readonly();

export type CreateEventRequest = z.infer<typeof CreateEventRequestSchema>;

export const UpdateEventRequestSchema = EventUpdateableHostViewSchema.extend({
  brandingUploads: EventBrandingUploadsSchema,
}).readonly();

export type UpdateEventRequest = z.infer<typeof UpdateEventRequestSchema>;
